/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createFavoriteListFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCreateFavoriteListRequest, serializeFavoriteList, type CreateFavoriteListRequest, type ErrorResponse, type FavoriteList, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { DefaultRequestBuilderRequestsMetadata, type DefaultRequestBuilder } from './defaultEscaped/index.js';
// @ts-ignore
import { type WithFavoriteListItemRequestBuilder, WithFavoriteListItemRequestBuilderNavigationMetadata, WithFavoriteListItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { SetDefaultRequestBuilderRequestsMetadata, type SetDefaultRequestBuilder } from './setDefault/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/favorites/{customerNumber-id}
 */
export interface CustomerNumberItemRequestBuilder extends BaseRequestBuilder<CustomerNumberItemRequestBuilder> {
    /**
     * The default property
     */
    get defaultEscaped(): DefaultRequestBuilder;
    /**
     * The setDefault property
     */
    get setDefault(): SetDefaultRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.favorites.item.item collection
     * @param favoriteListId Opaque identifier of the list, as returned when the list was created.
     * @returns {WithFavoriteListItemRequestBuilder}
     */
     byFavoriteListId(favoriteListId: string) : WithFavoriteListItemRequestBuilder;
    /**
     * Returns every favorite list the customer holds, each with its full items collection — there is no paging and no separate call to fetch items. At most one list carries isDefault. A customer with no lists yet is not an error: the response is an empty array, and an unknown customer number is indistinguishable from one that simply has no lists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FavoriteList[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<CustomerNumberItemRequestBuilderGetQueryParameters> | undefined) : Promise<FavoriteList[] | undefined>;
    /**
     * Creates an empty favorite list for the customer. List names are unique per customer: reusing a name that customer already has is rejected rather than merged into the existing list. A customer has at most one default list — the one GET /api/favorites/{customerNumber}/default returns — so creating this list with isDefault true moves the flag off whichever list held it; that list and its items are otherwise untouched. The customer number is taken as given and is not checked against the customer record.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FavoriteList>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateFavoriteListRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FavoriteList | undefined>;
    /**
     * Returns every favorite list the customer holds, each with its full items collection — there is no paging and no separate call to fetch items. At most one list carries isDefault. A customer with no lists yet is not an error: the response is an empty array, and an unknown customer number is indistinguishable from one that simply has no lists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CustomerNumberItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Creates an empty favorite list for the customer. List names are unique per customer: reusing a name that customer already has is rejected rather than merged into the existing list. A customer has at most one default list — the one GET /api/favorites/{customerNumber}/default returns — so creating this list with isDefault true moves the flag off whichever list held it; that list and its items are otherwise untouched. The customer number is taken as given and is not checked against the customer record.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateFavoriteListRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Returns every favorite list the customer holds, each with its full items collection — there is no paging and no separate call to fetch items. At most one list carries isDefault. A customer with no lists yet is not an error: the response is an empty array, and an unknown customer number is indistinguishable from one that simply has no lists.
 */
export interface CustomerNumberItemRequestBuilderGetQueryParameters {
    /**
     * Optional: OrganizationId to switch to (must be in the user's OrgCodes).
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const CustomerNumberItemRequestBuilderUriTemplate = "{+baseurl}/api/favorites/{customerNumber%2Did}{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CustomerNumberItemRequestBuilderNavigationMetadata: Record<Exclude<keyof CustomerNumberItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byFavoriteListId: {
        requestsMetadata: WithFavoriteListItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithFavoriteListItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["favoriteListId"],
    },
    defaultEscaped: {
        requestsMetadata: DefaultRequestBuilderRequestsMetadata,
    },
    setDefault: {
        requestsMetadata: SetDefaultRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CustomerNumberItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CustomerNumberItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createFavoriteListFromDiscriminatorValue,
    },
    post: {
        uriTemplate: CustomerNumberItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFavoriteListFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateFavoriteListRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
